import animationFrames from 'callbag-animation-frames';
import defer from 'callbag-defer';
import map from 'callbag-map';
var index =
/*#__PURE__*/
defer(function () {
  var start = Date.now();
  return map(function () {
    return Date.now() - start;
  })(animationFrames);
});
export default index;